import { Box, Container, Stack, Typography } from '@mui/material';

export default function PageShell({ eyebrow, title, intro, actions, children, maxWidth = 'xl' }) {
  return (
    <Container maxWidth={maxWidth} sx={{ py: { xs: 5, md: 7 } }}>
      <Stack spacing={2} sx={{ mb: 5, maxWidth: 920 }}>
        {eyebrow && (
          <Typography variant="overline" color="secondary.main" sx={{ fontWeight: 800, letterSpacing: '0.12em' }}>
            {eyebrow}
          </Typography>
        )}
        <Typography component="h1" variant="h2" sx={{ fontSize: { xs: '2.2rem', md: '3.25rem' } }}>
          {title}
        </Typography>
        {intro && <Typography color="text.secondary" sx={{ fontSize: '1.08rem', lineHeight: 1.75 }}>{intro}</Typography>}
        {actions && <Box>{actions}</Box>}
      </Stack>
      {children}
    </Container>
  );
}
